import { Trans, useLingui } from "@lingui/react/macro";
import { Plus, Trash2Icon } from "lucide-react";
import { observer } from "mobx-react-lite";
import { Duration } from "tinyduration";

import { FrequencyIntervalItem, RelativeDeltaModel } from "../../../api";
import { Button } from "../../../components/ui-kit/button";
import { NumberInput } from "../../../components/ui-kit/fields/number-input";
import { DurationEditor } from "./duration-editor";

export const FrequencyEditor = observer(function FrequencyEditor({
  items,
}: {
  items: FrequencyIntervalItem[];
}) {
  const { t } = useLingui();
  return (
    <div className="flex flex-col gap-2">
      {items.map((item, i) => (
        <div key={i} className="flex items-center gap-2 text-sm">
          <NumberInput
            value={item.count ?? undefined}
            onChange={(v) => {
              item.count = v;
            }}
            width={50}
            min={1}
            step={1}
          />
          <span>x</span>
          <DurationEditor
            value={toDuration(item.delta)}
            onChange={(delta) => {
              item.delta = delta ?? {};
            }}
            units={["years", "months", "days"]}
          />
          <Button
            type="button"
            variant="tertiary"
            destructive
            size="sm"
            icon={Trash2Icon}
            label={t`Remove interval`}
            onClick={() => void items.splice(i, 1)}
          />
        </div>
      ))}
      <div>
        <Button
          type="button"
          size="sm"
          icon={Plus}
          onClick={() => void items.push({ delta: { days: 0 } })}
        >
          <Trans>Add interval</Trans>
        </Button>
      </div>
    </div>
  );
});

/** Adapts the API's null-based `RelativeDeltaModel` to tinyduration's undefined-based `Duration`. */
function toDuration(delta: RelativeDeltaModel): Duration {
  return {
    years: delta.years ?? undefined,
    months: delta.months ?? undefined,
    days: delta.days ?? undefined,
    hours: delta.hours ?? undefined,
    minutes: delta.minutes ?? undefined,
    seconds: delta.seconds ?? undefined,
  };
}
